import React from "react";

const CollapseArrowIcon:React.FC = () => {
  return (
    <svg
      width="18"
      height="13"
      viewBox="0 0 18 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.40866 1.60282C1.79889 1.2126 2.43146 1.21225 2.82211 1.60205L8.29366 7.06169C8.68401 7.45119 9.31599 7.45119 9.70633 7.06169L15.1779 1.60205C15.5685 1.21226 16.2011 1.2126 16.5913 1.60282L17.2929 2.30438C17.6834 2.6949 17.6834 3.32807 17.2929 3.71859L9.7071 11.3044C9.31658 11.6949 8.68342 11.6949 8.29289 11.3044L0.707105 3.71859C0.316581 3.32807 0.316582 2.6949 0.707106 2.30438L1.40866 1.60282Z"
        fill="#8C8C8C"
      />
    </svg>
  );
};

export default CollapseArrowIcon;
